import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const CacioComponent = () => {
    const { folder, objectKey } = useParams();

    const safeObjectKey = encodeURIComponent(decodeURIComponent(objectKey));

    const redirectUrl = `https://cacio-gang-bucket.s3.eu-central-1.amazonaws.com/${folder}/${safeObjectKey}`;

    useEffect(() => {
        window.location.href = redirectUrl;
    }, [redirectUrl]);

    return (
        <div style={styles.container}>
            <img
                src="https://media.tenor.com/WPXBX1wj8WgAAAAi/fuck-you-middle-finger-gif.gif"
                alt="GIF importata"
                style={styles.image}
            />
        </div>
    );
};

const styles = {
    container: {
        margin: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#000",
    },
    image: {
        maxWidth: "100%",
        height: "auto",
    },
};

export default CacioComponent;